function TransferIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-6 h-6"
    >
      {/* Left arrow */}
      <path d="M7 17l-5-5 5-5" />
      <path d="M2 12h10" />
      {/* Right arrow */}
      <path d="M17 7l5 5-5 5" />
      <path d="M12 12h10" />
    </svg>
  )
}

export default TransferIcon
